import React from "react";
import { Icon } from "semantic-ui-react";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCarSide } from "@fortawesome/pro-solid-svg-icons";

import { APPOINTMENT_NOTE_TYPES } from "../../util/notes";
import { renderCarRegistration } from "../../util/common";

import "./index.scss";

const REPLACEMENT_TYPES = {
  HUURAUTO: "huurauto",
  HUURFIETS: "huurfiets",
};

const CommunicationReplacementCarInfo = ({ appointment, settings, t }) => {
  const { location_country = "NL" } = settings;

  const replacementCarNote = appointment.notes?.find(note => note.appointment_note_type_id === APPOINTMENT_NOTE_TYPES.REPLACEMENT_CAR);

  if (!replacementCarNote) return null;

  const { note, reg_nr, rental_pickup_time, rental_drop_off_time } = replacementCarNote;

  const handleFormatReplacementVehicleNote = note => {
    const lowerCaseNote = note.toLowerCase();

    if (lowerCaseNote.includes(REPLACEMENT_TYPES.HUURAUTO))
      return lowerCaseNote.replace(REPLACEMENT_TYPES.HUURAUTO, t("cc_replacement_vehicle").message || "Replacement vehicle").trim();
    else if (lowerCaseNote.includes(REPLACEMENT_TYPES.HUURFIETS))
      return lowerCaseNote.replace(REPLACEMENT_TYPES.HUURFIETS, t("cc_replacement_bicycle").message || "Replacement bicycle").trim();

    return "";
  };

  const getPickUpAndDropOfTimeStringReplacementCarNote = (rental_pickup_time, rental_drop_off_time) => {
    const pickupFormatted = rental_pickup_time ? moment(rental_pickup_time).format("DD-MM-YYYY HH:mm") : null;
    const dropoffFormatted = rental_drop_off_time ? moment(rental_drop_off_time).format("DD-MM-YYYY HH:mm") : null;

    if (pickupFormatted && dropoffFormatted) return `${pickupFormatted} > ${dropoffFormatted}`;
    else if (pickupFormatted) return pickupFormatted;
    else if (dropoffFormatted) return dropoffFormatted;
    else return "";
  };

  return (
    <div className="CommunicationReplacementCarInfo">
      <div className="header">
        <FontAwesomeIcon icon={faCarSide} />
        <span>{t("cc_replacement_car").message || "Replacement Car"}</span>
      </div>

      <div className="content-container">
        <div className="content">
          <div className="content-title">{t("cc_date").message || "Date"}</div>
          <div className="content-text">
            <Icon name="clock" />
            {handleFormatReplacementVehicleNote(note, t)} {getPickUpAndDropOfTimeStringReplacementCarNote(rental_pickup_time, rental_drop_off_time)}
          </div>
        </div>

        {reg_nr && (
          <div className="content">
            <div className="content-title">{t("cc_reg").message || "Reg"}#</div>

            <div className="content-text">{renderCarRegistration(location_country, reg_nr)}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(CommunicationReplacementCarInfo);
